const rateAlertsVisuals = [
  {
    src: "/images/xe/case-studies/rate-alerts/01-alerts-list.png",
    alt: "XE Rate Alerts list",
    caption: "Alerts list",
  },
  {
    src: "/images/xe/case-studies/rate-alerts/02-create-alert.png",
    alt: "XE screen for creating a target rate alert",
    caption: "Create an alert",
  },
  {
    src: "/images/xe/case-studies/rate-alerts/03-customize-alert.png",
    alt: "XE screen for customizing a rate alert",
    caption: "Customize the target",
  },
  {
    src: "/images/xe/case-studies/rate-alerts/04-alert-created.png",
    alt: "XE confirmation that a rate alert was created",
    caption: "Alert created",
  },
  {
    src: "/images/xe/case-studies/rate-alerts/05-manage-alert.png",
    alt: "XE screen for viewing, editing, or deleting a rate alert",
    caption: "Manage an alert",
  },
];

export default rateAlertsVisuals;
